<template>
  <div class="main">
      <!-- 选择手机号码 -->
      <div class="modal-fullscreen" :class="{'show': ui.showPhoneSelector}">
          <div class="modal-header">
              请选择手机号码
            <Icon :img="require('../../assets/icon-close-modal.png')" class="icon-close-modal" @click.native="doClosePhoneSelector"/>    
          </div>
          
          <PhoneSelector :id="selectedPhone.id" v-if="ui.showPhoneSelector" @change="doSelectPhone"/>
      </div>
      
      <!-- 兑换表单 -->
      <div class="card">
          <div class="phone-select">
              <label class="label">充值账户：</label>
              <span class="value">
                  {{selectedPhone.id > 0 ? selectedPhone.phone : '暂无'}}
                </span>
              <a href="javascript:;" class="action-btn" @click="doShowPhoneSelector">
                  {{selectedPhone.id > 0 ? '更换' : '添加'}}
              </a>
          </div>

          <div class="item-list">
              <a href="javascript:;" 
                v-for="n in numList" 
                :key="`num-${n.productId}`"
                class="item-wrap" 
                :class="{'selected': selectedNum.productId == n.productId}"
                @click="doSelectNum(n)" >
                  <span class="val">{{n.faceValue}}</span>
                  <span class="title">公共积分</span>
              </a>
          </div>

          <div class="summary-info">
              消耗{{pointUnit}}数量：
              <span class="num">
                  {{selectedNum.productId > 0 ? `${selectedNum.pricePoint}${pointUnit}` : '--'}}
              </span>
          </div>

          <div class="actions">
              <a href="javascript:;" class="primary-btn" :class="{'disable': !isValid}" @click="doCharge">
                  {{isValid ? '确认充值':'请选择档位和账户'}}
                </a>
              <a href="javascript:;" class="sub-btn" @click="go('/pages/wenhuajifen/Orders')">充值记录<Icon :img="require('../../assets/c_icon.png')" class="icon-link"/></a>
          </div>

      </div>
      <!-- 介绍 -->
      <div class="card">
          <div class="brand-logo-wrap">
              <img :src="require('../../assets/biaoti_img.png')" class="brand-logo"/>
          </div>
          
          <div class="text">
1、文旅公共积分是一种被严格监管，符合银联标准的货币化数字资产，其价值与人民币比例恒定为1：1。<br/>
2、积分兑换后在微信小程序内搜索“文旅公共积分”，在小程序内把积分余额转到“银联通付卡”内。<br/>
3、打开银联“云闪付”APP，绑定“银联通付卡”，选择此卡在标有银联的商户支付消费。<br/>
4、兑换时，请填写正确的手机号码，如因手机号码错误、欠费导致问题，概不负责。<br/>
5、单日累计兑换上限为2000元。
          </div>
      </div>

      <!-- 兑换成功 -->
      <Dialog ref="chargeSuccessModal" title="兑换成功" type="success" button="继续兑换">
          <template slot="body">
              <div>
                  兑换成功
                  <br/>
                  是否继续兑换？
              </div>
              
          </template>
          <template slot="footer">
              <a href="javascript:;" class="modal-sub-btn" @click="go('/pages/wenhuajifen/Orders')">查看订单</a>
          </template>
      </Dialog>

      <!-- 兑换失败 -->
      <Dialog ref="chargeFailedModal" title="兑换失败" type="error" button="我知道了">
          <template slot="body">
              <div>
                  {{errMsg}}，支付失败
              </div>
              
          </template>
      </Dialog>

      <!-- 确认兑换 -->
      <Dialog ref="chargeConfirmModal" title="确认兑换" type="none" button="确认兑换" @confirm="doConfirmCharge">
          <template slot="body">
              <div>
                  使用{{selectedNum.pricePoint}}{{pointUnit}}兑换{{selectedNum.faceValue}}公共积分，是否确认兑换？
              </div>
          </template>
      </Dialog>
  </div>
</template>

<script>
import PhoneSelector from '@/components/common/PhoneSelector'

import api from '../../api'

export default {
  title: '文旅公共积分充值',
  bodyClass:'gray-bg',
  components: { PhoneSelector },
  data () {
    return {
        ui: {
            //是否显示手机选项列表
            showPhoneSelector: false
        },
        errMsg: '',
        pointUnit: api.store.loginedUser.config.pointName,
        //积分面额列表
        numList: [
            // {
            //     faceValue:30,
            //     pricePoint:3000,
            //     productId:1
            // }
        ],
        //用户选择的手机号码
        selectedPhone: {
            id: -1,
            phone: ''
        },
        //用户选择的面额
        selectedNum: {
            productId: -1,
            faceValue: 0,
            pricePoint: 0
        }
    }
  },
  computed: {
      //用户是否已经选择好 面额 和 手机号码
      isValid(){
          return this.selectedNum.productId > 0 && this.selectedPhone.id > 0
      }
  },
  methods:{
    loadData(){
        this.$showLoading('加载中...');
        api.jifentong.productList(r=>{
            console.log(r);
            this.$hideLoading();

            r.list.forEach(e => {
                this.numList.push(e)
            });
        }, r=>{
            this.$alertDialog(r.msg);
            this.$hideLoading();

        })

        api.jifentong.defaultPhone(r=>{
            if(r.phone){
                this.selectedPhone.id = 1
                this.selectedPhone.phone = r.phone
            }
            
        })
    },
    go(path){
        this.$routerPush(this, path);
    },
    doShowPhoneSelector(){
        this.ui.showPhoneSelector = true
    },
    doClosePhoneSelector(){
        this.ui.showPhoneSelector = false
    },
    doSelectPhone(phoneItem){
        this.selectedPhone.id = phoneItem.id;
        this.selectedPhone.phone = phoneItem.phone;
        this.doClosePhoneSelector();
    },
    doSelectNum(n){
        this.selectedNum = n;
    },
    doCharge(){
        if(this.isValid){
            this.$refs.chargeConfirmModal.display()
        }
    },
    doConfirmCharge(){
        this.$showLoading('兑换中...');
        api.jifentong.charge(
            this.selectedPhone.phone, 
            this.selectedNum.pricePoint,
            this.selectedNum.productId,
            r=>{
                console.log(r)
                this.$hideLoading()
                this.$refs.chargeSuccessModal.display()
            },
            r=>{
                console.log(r)
                this.$hideLoading()
                this.errMsg = r.msg || '账户余额不足'
                this.$refs.chargeFailedModal.display()
            }
        )
        
        
    }
  },
  mounted(){
    this.loadData()
    // this.$hideLoading();
  }
}
</script>

<style scoped lang="less">
@contentW: 86.67vw;

.main{
    padding-top: 2.67vw;
    padding-bottom: 2.67vw;

}

.card{
    width: 94.67vw;
    margin: 0 auto 2.67vw;
    background: #fff;
    border-radius: 1.33vw;
}

.phone-select{
    width: @contentW;
    border-bottom: 1px solid #e6e6e6;
    margin: 0 auto;
    padding: 4vw 0;
    line-height: 8.53vw;
    font-size: 4.27vw;

    .label{
        color: #999999;
    }

    .value{
        color: #333333;
    }


    .action-btn{
        float: right;
        color:#499DF2;
        border: 1px solid #499DF2;
        border-radius: 1.33vw;
        font-size: 4vw;
        line-height: 8.53vw;
        width: 16vw;
        text-align: center;
    }
}

.item-list{
    text-align: left;
    margin-top: 6.67vw;
    padding-left: 2.5vw;

 
 .item-wrap{
    display: inline-block;
    background: #F2F2F2;
    color: #333;
    width: 26.67vw;
    height: 16vw;
    border-radius: 0.8vw;
    margin: 1.33vw 1.6vw;
    font-size: 4.53vw;

    .val{
        display: block;
        font-weight: bold;
        line-height: 2em;
        text-align: center;
    }

    .title{
        display: block;
        text-align: center;
        font-size: 3.47vw;
    }

    &.selected{
        background: #F24949;
        color: #fff;
    }
 }
}

.summary-info{
    color: #999;
    width: @contentW;
    margin: 2.67vw auto;
    text-align: left;

    .num{
        color: #333;
    }
}

.actions{
    
    width: @contentW;
    margin: 10.27vw auto;
    text-align: center;

    .primary-btn{
        display: block;
        width: 100%;
        font-size: 4.53vw;
        text-align: center;
        color: white;
        border-radius: 0.8vw;
        line-height: 13.33vw;
        background-image: linear-gradient(to right, #FF4D4C, #FF6A4C);

        &.disable{
            background: #999999;
        }
    }

    .sub-btn{
        display: inline-block;
        color: #999;
        margin: 6.67vw auto;

        .icon-link{
            display: inline-block;
            width: 1.6vw;
            height: 2.67vw;
            margin-left: 1.33vw;
        }
    }

}

.brand-logo-wrap{
    padding: 5.33vw 0;
    .brand-logo{
        display: block;
        width: 52vw;
        margin: 0 auto ;
    }
}


.text{
    width: @contentW;
    color: #999;
    margin: 0 auto;
    padding-bottom: 6.67vw;
    line-height: 1.8em;
}

.modal-fullscreen{
    position: fixed;
    top: 0;
    right: -100vw;
    z-index: 1000;
    width: 100vw;
    height: 100vh;
    background: white;
    transition: all .3s ease;

    .modal-header{
        height: 12vw;
        line-height: 12vw;
        font-size: 4vw;
        color: #333;
        text-align: center;
        border-bottom: 1px solid #d3d3d3;

    }

    .icon-close-modal{
        position: absolute;
        top: 4vw;
        right: 4vw;
        width: 4vw;
        height: 4vw;
        z-index: 2;
    }


    &.show{
        right: 0;
    }
}

.modal-sub-btn{
    color: #499DF2;
    display: inline-block;
    font-size: 4.8vw;
    line-height: 2.6em;
}

</style>



// WEBPACK FOOTER //
// src/pages/wenhuajifen/Charge.vue